import { AncestorProject } from 'types'
import { FolderIcon } from 'common/FolderIcon'

type ProjectLink = Pick<
  AncestorProject,
  'id' | 'title' | 'handbook' | 'header_emoji' | 'default_project' | 'ancestor_projects'
>

export const buildAncestorProject = (parent: ProjectLink, onClick: () => void) => {
  const { id, title, header_emoji, default_project, ancestor_projects } = parent

  const icon = () => {
    return <FolderIcon defaultFolder={!!default_project} header_emoji={header_emoji} />
  }

  return {
    title: title,
    id,
    onClick: onClick,
    defaultFolder: !!default_project,
    ancestor_projects,
    icon: icon(),
    to: '',
  }
}
